import React from 'react';
import { toast, ToastItem } from '../utils/toast';

const typeToClass: Record<ToastItem['type'], string> = {
  success: 'bg-success text-white',
  error: 'bg-danger text-white',
  info: 'bg-primary text-white',
  warning: 'bg-warning text-dark',
};

const ToastHost: React.FC = () => {
  const [toasts, setToasts] = React.useState<ToastItem[]>([]);

  React.useEffect(() => {
    return toast.subscribe(setToasts);
  }, []);

  return (
    <div style={{ position: 'fixed', top: 16, right: 16, zIndex: 1060, display: 'flex', flexDirection: 'column', gap: 8 }}>
      {toasts.map(t => (
        <div key={t.id} className={`toast show ${typeToClass[t.type]}`} role="alert" aria-live="assertive" aria-atomic="true">
          <div className="toast-body d-flex align-items-center justify-content-between" style={{ minWidth: 280 }}>
            <span>{t.message}</span>
            <button type="button" className="btn-close btn-close-white ms-2" onClick={() => toast.dismiss(t.id)} aria-label="Close"></button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToastHost;


